import * as React from 'react'
import { FC } from 'react'
import { Field } from 'formik'
import { BaseTextField } from '@user/components/Formik'
import MenuItem from '@mui/material/MenuItem'

interface Props {
  label?: string
}

export const SoldServiceDayRangeSelect: FC<Props> = (props) => {
  const { label } = props

  return (
    <Field name="numberOfDays" component={BaseTextField} label={label} select>
      <MenuItem value="30">30 days</MenuItem>
      <MenuItem value="60">60 days</MenuItem>
      <MenuItem value="90">90 days</MenuItem>
    </Field>
  )
}
SoldServiceDayRangeSelect.displayName = 'SoldServiceDayRangeSelect'
